import React, {useEffect} from "react";
import {ArrowPathIcon} from "@heroicons/react/24/outline";
import {classNames} from "../../../../../util/util-helpers";
import {useLocation} from "react-router-dom";

export default function DriverPrimaryDispatcher({
                                                    data,
                                                    fetchData,
                                                    setIsDispatchersDialogOpen,
                                                    isDispatcherChanged,
                                                    setIsDispatcherChanged
                                                }) {
    const location = useLocation();
    const canSelectDispatch = location.pathname === '/command-center';
    const primaryDispatcher = (data?.Dispatchers ?? []).find(it => it.IsPrimary);
    const dispatcherName = primaryDispatcher?.FirstName + " " + primaryDispatcher?.LastName;


    function handleUpdateDispatcherClick() {
        setIsDispatchersDialogOpen(true);
    }

    useEffect(() => {
        if (canSelectDispatch && isDispatcherChanged) {
            fetchData();
            setIsDispatcherChanged(false);
        }
    }, [canSelectDispatch, isDispatcherChanged]);

    return <>
        <div className="my-8">
            <div className="font-bold leading-5 mb-2 text-base">
                Primary dispatcher
            </div>

            <button
                onClick={handleUpdateDispatcherClick}
                disabled={!canSelectDispatch}
                className={
                    classNames(
                        "w-full bg-inverse rounded-xl border-tm-gray-300 border shadow-card px-6 py-2 flex items-center",
                        canSelectDispatch ? "cursor-pointer hover:bg-tm-gray-50 hover:text-primary" : undefined
                    )
                }
            >
                <div
                    className="font-bold break-all whitespace-pre-wrap text-xs">{primaryDispatcher ? dispatcherName : "No dispatcher selected"}</div>

                {canSelectDispatch && (
                    <ArrowPathIcon className="size-5 ml-auto"/>
                )}
            </button>
        </div>
    </>
}